import React from 'react'
import { OneColorIconProps } from '../utils'

export const PopcornIcon: React.FC<OneColorIconProps> = ({ size = 48, className }) => {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 41 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_4998_476494)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.82141 9.55541C6.93665 12.0036 13.0004 13.9441 20.4562 13.9016C26.9677 13.8644 32.3995 12.3266 33.7301 10.3062C33.4269 9.96924 33.0082 9.73816 32.5365 9.67556C32.5416 9.61608 32.5448 9.55616 32.5445 9.49534C32.539 8.52716 31.8288 7.72984 30.9035 7.58114C30.9279 7.45593 30.9407 7.32642 30.9399 7.19393C30.9338 6.11571 30.0547 5.24671 28.9765 5.25281C28.9521 5.25296 28.9283 5.25593 28.9041 5.25697C28.9731 5.05534 29.0117 4.83987 29.0106 4.61489C29.0043 3.53668 28.1253 2.66768 27.0471 2.67378C26.7997 2.67526 26.5643 2.72448 26.3469 2.80969C26.0385 2.22917 25.4464 1.82456 24.756 1.77787C24.6357 0.809687 23.8086 0.0627722 22.8089 0.0683909C22.1798 0.0719915 21.6233 0.374148 21.269 0.838237C20.9096 0.447159 20.3945 0.201806 19.8216 0.205077C18.7433 0.211174 17.8743 1.09028 17.8804 2.16835C17.8816 2.3743 17.9151 2.57221 17.9752 2.75824C17.5352 2.83987 17.1482 3.06857 16.8654 3.39169C16.6409 2.55541 15.8773 1.94084 14.9707 1.9459C14.1237 1.9508 13.4079 2.49534 13.142 3.25088C12.4224 3.54188 11.916 4.24775 11.9207 5.0711C11.9218 5.254 11.9497 5.43006 11.9978 5.59779C11.7551 5.49162 11.4876 5.43214 11.2056 5.43378C10.3555 5.43868 9.63747 5.98708 9.37382 6.74709C9.12103 6.62961 8.83999 6.56285 8.54274 6.56463C7.46453 6.57073 6.59538 7.44969 6.6016 8.5279C6.60356 8.88344 6.70215 9.21534 6.86988 9.50143C6.85278 9.51868 6.83776 9.53757 6.82141 9.55541Z"
          fill="#F9D320"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M31.043 34.0858C30.4699 34.9561 29.3563 35.8574 28.1908 36.4583L30.1832 16.2497C31.4509 15.8424 32.6879 15.3028 33.5991 14.5289L31.043 34.0858ZM26.208 37.3013C24.2787 37.9398 23.1569 38.1377 21.5509 38.2953L21.8012 17.5286C23.5753 17.4778 25.8712 17.2373 27.8275 16.8198L26.208 37.3013ZM14.7053 37.3013L13.086 16.8198C15.0421 17.2373 17.338 17.4778 19.1121 17.5286L19.3624 38.2953C17.7564 38.1377 16.6348 37.9398 14.7053 37.3013ZM9.8705 34.0858L7.31422 14.5289C8.22544 15.3028 9.46247 15.8424 10.7301 16.2497L12.7225 36.4583C11.557 35.8574 10.4434 34.9561 9.8705 34.0858ZM30.9001 6.8125C30.9254 6.93592 30.9395 7.0635 30.9402 7.19451C30.941 7.327 30.9282 7.45651 30.9037 7.58172C31.8292 7.73027 32.5394 8.52759 32.5449 9.49592C32.5452 9.55659 32.5419 9.61666 32.5368 9.67599C33.0085 9.7386 33.4272 9.96967 33.7304 10.3066C32.4 12.3271 26.968 13.865 20.4567 13.9023C13.0009 13.945 6.93712 12.0046 6.82173 9.55629C6.83808 9.5386 6.8531 9.51956 6.8702 9.50246C6.75511 9.30618 6.6757 9.08744 6.63466 8.85532C5.92076 9.53295 5.48879 10.0793 5.56477 10.8748C5.57206 10.9811 8.72314 33.5425 8.72314 33.5425C9.08671 37.1157 14.2756 39.9716 20.4567 40.007C26.6378 39.9716 31.8268 37.1157 32.1902 33.5425C32.1902 33.5425 35.3413 10.9811 35.3486 10.8748C35.4995 9.28358 33.6376 7.83912 30.9001 6.8125Z"
          fill="#DB382A"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.0859 16.8184L14.7053 37.2998C16.6348 37.9384 17.7564 38.1363 19.3624 38.2939L19.1121 17.5272C17.338 17.4764 15.0421 17.2359 13.0859 16.8184Z"
          fill="#FFFFFE"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M21.551 38.2939C23.157 38.1363 24.2786 37.9384 26.2081 37.2998L27.8275 16.8184C25.8713 17.2359 23.5754 17.4764 21.8013 17.5272L21.551 38.2939Z"
          fill="#FFFFFE"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M28.1907 36.4587C29.3562 35.8578 30.4698 34.9565 31.0427 34.0862L33.599 14.5293C32.6878 15.3031 31.4507 15.8428 30.1831 16.25L28.1907 36.4587Z"
          fill="#FFFFFE"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.31421 14.5293L9.87034 34.0862C10.4434 34.9565 11.557 35.8578 12.7225 36.4587L10.7301 16.25C9.46246 15.8428 8.22544 15.3031 7.31421 14.5293Z"
          fill="#FFFFFE"
        />
      </g>
      <defs>
        <clipPath id="clip0_4998_476494">
          <rect width="40" height="40" fill="white" transform="translate(0.5)" />
        </clipPath>
      </defs>
    </svg>
  )
}
